import SpinModel from "../model/SpinModel";
import { State } from "./State";
import ViewManager from "../../../core/src/utils/ViewManager";
import App from "../../../core/src/App";
import GameEvents from "../const/GameEvents";
import ReelGroup from "../../src/views/ReelGroup";
import { DefaultLayers } from "../../src/utils/Layers";
import { Tween } from "./../Tween";
import GameModel from "../model/GameModel";
import CommandManager from "../commands/CommandManager";
import { Commands } from "../commands/CommandEnum";
import KeyboardManager, { Key } from "../utils/KeyboardManager";
import AutoplayModel from "../model/AutoplayModel";
import Utils from "../utils/Utils";
import UIController from "../ui/UIController";
import { UIStates } from "../ui/UIStates";

export default class ShowWinState extends State {
    protected reelGroup: ReelGroup;
    private hideWinTween: Tween;

    // Override for more complex logic.
    protected get haveBangup(): boolean {
        return App.config.bangupWin;
    }

    public enter(): void {
        super.enter();
        const scene = ViewManager.getLayer(DefaultLayers.Reels).getCurrentScene();
        this.reelGroup = scene.getSubView("ReelGroup") as ReelGroup;
        this.attachOnCompleteEvent();
        this.displayWin();

        if (SpinModel.isInFreespins() && !GameModel.gameConfig.totalWinFromServer) {
            SpinModel.updateFreespinWinnings();
        }

        if (GameModel.spaceToSpin) {
            if (GameModel.alowSpaceToSkipSpin() && KeyboardManager.isPressed(Key.SPACE)) {
                this.spinWithKey();
            } else {
                KeyboardManager.onKey("pressed", Key.SPACE, this.spinWithKey, this);
            }
        }

        this.hideWinTween = Tween.delayedCall(
            this.getShowWinDuration(),
            () => {
                ViewManager.getLayer(DefaultLayers.PaylineCelebration).clear();
                App.dispatcher.off(GameEvents.START_SPIN, this.onSpinStarted, this);
            },
            [],
            this);

         App.dispatcher.once(GameEvents.START_SPIN, this.onSpinStarted, this);
    }

    public canExit(): boolean {
        /**
         * Override method to alow externel skip of state
         */
        return App.config.canSkipWin;
    }

    displayWin() {
        if (!SpinModel.hasBigWin()) {
            CommandManager.execute(Commands.UPDATE_WIN);
        } else {
            // We do not want the user to be able to spin.
            // TODO: Use UIStates.BIG_WIN, but implement it at UIDesktop first.
            // Note that each vendor core (both relax [which has template branch too] and alt) must do this!
            UIController.setState(UIStates.SPIN);
        }

        if (!SpinModel.isInFreespins()) {
            CommandManager.execute(Commands.UPDATE_BALANCE);
        }
        console.log("IVAN getCurrentWinsData",SpinModel.getCurrentWinsData());
        console.log("IVAN getCurrentWin",SpinModel.getCurrentWin());
        console.log("IVAN getAccumulatedWin()", SpinModel.getAccumulatedWin());

       
        this.reelGroup.displaySummaryResult(SpinModel.getCurrentWinsData());

        if (SpinModel.getCurrentWin() > 0) {
            this.reelGroup.winlinesView.setWinBannerValue(
                SpinModel.getCurrentWin(),
                this.haveBangup
            );
        }
    }


    public exit(): void {
        if (GameModel.spaceToSpin) {
            KeyboardManager.offKey("pressed", Key.SPACE, this.spinWithKey, this);
        }

        super.exit();

        this.reelGroup.winlinesView.off(
            GameEvents.BANNER_ANIM_COMPLETE,
            this.exit,
            this
        );
    }

    protected attachOnCompleteEvent() {
         this.reelGroup.winlinesView.once(
            GameEvents.BANNER_ANIM_COMPLETE,
            () => {
                Tween.delayedCall(this.getUnlockTime(), () => {
                    this.exit();
                })
            },
            this
        );
    }

    protected spinWithKey() {
        if (GameModel.spaceToSpin) {
            CommandManager.execute(Commands.SPIN);
        }
    }

    /**
     * Gets the state exit time.
     * Usually the default exit time equals 0,
     * but we might wish to wait a little bit, when we have some feature in example,
     * so the user will be able to see the win amount.
     * 
     * The user won't be able to click the spin button, during this time frame.
     * Notice the space bar spin will be still active.
     *
     * @protected
     * @return {*}  {number}
     * @memberof ShowWinState
     */
    protected getUnlockTime(): number {
        // By default we unlock the spin button immediately.
        let delay = 0;

        if (SpinModel.hasBigWin() || SpinModel.isInFreespins() || SpinModel.isInRespins() || SpinModel.inFreegames() || AutoplayModel.isAutoSpinActive() || SpinModel.freespinsWon > 0) {
            // But since we have a feature, we hold the spin button locked for a while.
            delay = Utils.isNumeric(App.config.showWinUnLockTime)
                ? Number(App.config.showWinUnLockTime)
                : 1.5;
        }

        return delay;
    }

    /**
     * Defines how many seconds the win amount is visible to the user,
     * before it gets cleared.
     *
     * @protected
     * @return {*}  {number}
     * @memberof ShowWinState
     */
    protected getShowWinDuration(): number {
        return Utils.isNumeric(App.config.showWinDuration)
            ? Number(App.config.showWinDuration)
            : 3.0;
    }

    private onSpinStarted() {
        // When the user spins, we need to kill the ongoing hide win tween.
        if (this.hideWinTween) {
            this.hideWinTween.kill();
            this.hideWinTween = undefined;
        }
    }
}
